import '@catalogo/shell-web/src/helpers/b2w_pid';
import React from 'react';
import { hydrate, render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { loadableReady } from '@loadable/component';
import { metricsInit } from '@catalogo/core-metrics';
import { SwitchComponent } from '@catalogo/core-switch-component';
import '@catalogo/core-metrics-worker';
import { ApolloProvider } from '@apollo/client';
import { getClient } from '@catalogo/core-graphql-client';
import clearCookies from './clear-cookies';
import Reset from '../helpers/reset';
import App from '../app';

const client = getClient({});

metricsInit(client);
clearCookies();

const app = (
  <ApolloProvider client={client}>
    <BrowserRouter>
      <SwitchComponent component="theme-provider">
        <SwitchComponent component="global-style" />
        <Reset />
        <App client={client} />
      </SwitchComponent>
    </BrowserRouter>
  </ApolloProvider>
);

loadableReady(() => {
  // https://github.com/react-static/react-static/issues/144#issuecomment-348270365
  /* istanbul ignore next */
  const renderMethod = module.hot ? render : hydrate;
  renderMethod(app, document.getElementById('root'));
});

/* istanbul ignore next */
if (module.hot) {
  module.hot.accept();
}
